// Based on https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/
window.initializePromoClock = function(selector) {
  function getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)));
    return {
      'total': t,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  var $clock = $(selector);
  if ( $clock.length === 0 ) { return } // clock not present

  // Integer value representing the number of milliseconds since
  // "1 January 1970 00:00:00 UTC", with leap seconds ignored (Unix Epoch; but
  // consider that most Unix time stamp functions count in seconds).
  // You can get this via: Time.parse("2016-12-5 05:00:00 UTC").to_i * 1000
  var dataEpoch = $clock.data('epoch');

  if ( typeof dataEpoch == 'undefined' ) {
    console.error("data-epoch attribute is not defined on " + selector);
    return
  }
  var deadlineEpoch = Number(dataEpoch);
  var deadline = new Date(deadlineEpoch);

  var $hours = $clock.find('.hours');
  var $minutes = $clock.find('.minutes');
  var $seconds = $clock.find('.seconds');

  function zeroPad(num) { return ('0' + num).slice(-2); }

  function updateClock() {
    var t = getTimeRemaining(deadline);

    $hours.text(zeroPad(t.hours));
    $minutes.text(zeroPad(t.minutes));
    $seconds.text(zeroPad(t.seconds));

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}

$(document).ready(function() {
  initializePromoClock('.js-promo-counter-v2');
});
